export type PresentationMotionSample={x:number;z:number;timeMs:number}
export type PresentationMotionKinematics={vx:number;vz:number;planarSpeed:number;speedRatio:number}
export type PresentationMotionTracker={sample:PresentationMotionSample;motion:PresentationMotionKinematics;lastMovingAt:number}

const ZERO:PresentationMotionKinematics={vx:0,vz:0,planarSpeed:0,speedRatio:0}

export function createPresentationMotionSample(x:number,z:number,timeMs:number):PresentationMotionSample{
 return{x:Number.isFinite(x)?x:0,z:Number.isFinite(z)?z:0,timeMs:Number.isFinite(timeMs)?timeMs:0}
}

export function derivePresentationMotion(previous:PresentationMotionSample,x:number,z:number,timeMs:number,baseSpeed:number){
 const next=createPresentationMotionSample(x,z,timeMs)
 if(!Number.isFinite(x)||!Number.isFinite(z)||!Number.isFinite(timeMs)||!Number.isFinite(baseSpeed)||baseSpeed<=0)return{sample:next,motion:ZERO}
 const dt=(timeMs-previous.timeMs)/1000
 if(!Number.isFinite(dt)||dt<=0||dt>.25)return{sample:next,motion:ZERO}
 let vx=(x-previous.x)/dt,vz=(z-previous.z)/dt
 if(!Number.isFinite(vx)||!Number.isFinite(vz))return{sample:next,motion:ZERO}
 let planarSpeed=Math.hypot(vx,vz)
 const plausibleMax=baseSpeed*2.55
 if(planarSpeed>plausibleMax*1.7)return{sample:next,motion:ZERO}
 if(planarSpeed>plausibleMax){const scale=plausibleMax/planarSpeed;vx*=scale;vz*=scale;planarSpeed=plausibleMax}
 const speedRatio=Math.max(0,Math.min(2.2,planarSpeed/baseSpeed))
 return{sample:next,motion:{vx,vz,planarSpeed,speedRatio}}
}


export function createPresentationMotionTracker(x:number,z:number,timeMs:number):PresentationMotionTracker{
 const sample=createPresentationMotionSample(x,z,timeMs)
 return{sample,motion:ZERO,lastMovingAt:sample.timeMs}
}

export function updatePresentationMotionTracker(
 previous:PresentationMotionTracker,x:number,z:number,timeMs:number,baseSpeed:number,holdMs=180,
):PresentationMotionTracker{
 const next=derivePresentationMotion(previous.sample,x,z,timeMs,baseSpeed)
 const moving=next.motion.planarSpeed>.08
 if(moving)return{sample:next.sample,motion:next.motion,lastMovingAt:next.sample.timeMs}
 const unchanged=Math.hypot(next.sample.x-previous.sample.x,next.sample.z-previous.sample.z)<=.001
 const sinceMove=next.sample.timeMs-previous.lastMovingAt
 const hold=unchanged&&previous.motion.planarSpeed>.08&&Number.isFinite(sinceMove)&&sinceMove>=0&&sinceMove<=Math.max(0,holdMs)
 return{sample:next.sample,motion:hold?previous.motion:ZERO,lastMovingAt:previous.lastMovingAt}
}
